import React from 'react';
import MenuCliente from '../Components/MenuCliente/menucliente';
import './tutorial.css';

function Tutorial(){
    return <div>      
      <MenuCliente />      
    </div>;
  }

export default Tutorial;